const defaultState = {
	lastViewedVehiclesPage: [],
	isDevicesHaveProblems: false,
	hasUnacknowledgedAlerts: false,
	initialAssets: [],
	selectedAssets: [],
	sortProps: {
		sortAssetsName: 'vehicle_name',
		sortAssetsOrder: 'asc',
	},
}

const assets = (state = defaultState, action) => {
	switch (action.type) {
		case 'SET_IS_DEVICES_HAVE_PROBLEMS': {
			return { ...state, isDevicesHaveProblems: action.payload }
		}
		case 'SET_LAST_VIEWED_ASSETS': {
			return { ...state, lastViewedVehiclesPage: action.payload }
		}
		case 'SET_HAS_UNACKNOWLEDGED_ALERTS': {
			return { ...state, hasUnacknowledgedAlerts: action.payload }
		}
		case 'SET_INITIAL_ASSETS': {
			return { ...state, initialAssets: action.payload }
		}
		case 'SET_SELECTED_ASSETS': {
			return { ...state, selectedAssets: action.payload }
		}
		case 'SET_SORT_PROPS': {
			return { ...state, sortProps: action.payload }
		}
		default:
			return state
	}
}

export default assets
